import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { green } from "@mui/material/colors";

const StyledIconButton = (props) => {
  return (
    <Box
      sx={{
        m: 1,
        position: "relative",
      }}
    >
      {props.children}
      {props.loadingStatus && (
        <CircularProgress
          size={25}
          sx={{
            color: props.loadingColor ? props.loadingColor : green[500],
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 13,
          }}
        />
      )}
    </Box>
  );
};

export default StyledIconButton;
